export default __webpack_public_path__ + "static/media/card-consumption.07cadea8.png";